import { Route, Switch } from 'react-router-dom';
import UserManagement from './UserManagement';

const UserManagementRouter = () => {
  return (
    <>
      <Switch>
        <Route path="/projects/:projectId/team-members">
          <UserManagement />
        </Route>
      </Switch>
    </>
  );
};

export default UserManagementRouter;
